import { ca } from '@cian/analytics';

import { adAnalyticsCategory } from '../../../../scripts/services/analytics.service';

export const trackSelectKP = (kpId) => {
  ca('event', {
    name: 'oldevent',
    category: adAnalyticsCategory, // 'New_ad' | 'Edit_ad'
    action: 'GEO',
    label: `add_KP/${kpId}`,
  });
};
